export default __webpack_public_path__ + "static/media/login-bg-33.ee327cfa.jpg";